import get from 'lodash.get';

const getHighlightedPlanType = (plans) => {
  if (!plans.length) return '';
  const plan = plans.find((item) => item.highlighted);

  return get(plan, 'type', '');
};

export default getHighlightedPlanType;
